import ResultSMap from './ResultSMap';

export default ResultSMap;
